import { useTranslation } from "react-i18next";

import { unescapeSkillAnchors } from "../SkillAnchor";
import Item from "./Item";
import Title from "./Title";

export default function Xp() {
	const { t } = useTranslation();

	return (
		<div id="xp">
			<Title>{t("xp.title")}</Title>

			<div className="mx-auto w-3/4 flex flex-col">
				<Item
					id="niryo"
					title={t("internship")}
					date={`${t("avril")} - ${t("november")} 2024`}
					where="Niryo - Wambrechies"
					logo="imgs/niryo-i.png"
					logoClass="h-6 my-4"
					skills={(
						t("xp.1.list", {
							returnObjects: true,
						}) as string[]
					)
						.slice(1)
						.map(unescapeSkillAnchors)}
					desc={
						<>
							<span className="font-bold">{t("context")}</span>:
							<p className="py-4">{t("xp.niryo.0")}</p>
							<span className="font-bold">{t("role")}</span>:
							<p className="py-4">{t("xp.niryo.1")}</p>
							<p>{t("xp.niryo.2")}</p>
							<ul className="pl-4 list-disc py-4">
								<li>{t("xp.niryo.3")}</li>
								<li>{t("xp.niryo.4")}</li>
								<li>{t("xp.niryo.5")}</li>
								<li>{t("xp.niryo.6")}</li>
								<li>{t("xp.niryo.7")}</li>
								<li>{t("xp.niryo.8")}</li>
							</ul>
							<p>{t("xp.niryo.9")}</p>
						</>
					}
				></Item>{" "}
				<Item
					id="ter"
					title={t("ter")}
					date={`${t("avril")} - ${t("juin")} 2023`}
					where={t("perrin") + " - Lens"}
					logo="imgs/artois.png"
					skills={(
						t("xp.2.list", {
							returnObjects: true,
						}) as string[]
					)
						.slice(1)
						.map(unescapeSkillAnchors)}
					desc={
						<>
							<span className="font-bold">{t("context")}</span>:
							<p className="py-4">{t("xp.ter.0")}</p>
							<span className="font-bold">{t("role")}</span>:
							<p className="py-4">{t("xp.ter.1")}</p>
							<p>{t("xp.ter.2")}</p>
							<p>{t("xp.ter.3")}</p>
							<ul className="pl-4 list-disc py-4">
								<li>{t("xp.ter.4")}</li>
								<li>{t("xp.ter.5")}</li>
								<li>{t("xp.ter.6")}</li>
							</ul>
							<p>{t("xp.ter.7")}</p>
						</>
					}
				></Item>{" "}
				<Item
					id="alloa"
					title={t("internshipcdd")}
					date={`${t("avril")} - ${t("Juillet")} 2022`}
					where="Alloa - Lille"
					logo="imgs/alloa.png"
					logoClass="w-28 h-12"
					skills={(
						t("xp.3.list", {
							returnObjects: true,
						}) as string[]
					)
						.slice(1)
						.map(unescapeSkillAnchors)}
					desc={
						<>
							<span className="font-bold">{t("context")}</span>:
							<p className="py-4">{t("xp.alloa.0")}</p>
							<p>{t("xp.alloa.1")}</p>
							<p className="py-4">{t("xp.alloa.2")}</p>
							<span className="font-bold">{t("role")}</span>:
							<p className="py-4">{t("xp.alloa.3")}</p>
							<p>{t("xp.alloa.4")}</p>
							<ul className="pl-4 list-disc py-4">
								<li>{t("xp.alloa.5")}</li>
								<li>{t("xp.alloa.6")}</li>
								<li>{t("xp.alloa.7")}</li>
								<li>{t("xp.alloa.8")}</li>
							</ul>
							<p>{t("xp.alloa.9")}</p>
							<ul className="pl-4 list-disc py-4">
								<li>{t("xp.alloa.10")}</li>
								<li>{t("xp.alloa.11")}</li>
								<li>{t("xp.alloa.12")}</li>
							</ul>
						</>
					}
				></Item>
				<Item
					id="iemn"
					title={t("internship")}
					date={`${t("avril")} - ${t("juin")} 2021`}
					where="IEMN - Villeneuve-d'Ascq"
					logo="imgs/iemn-i.png"
					logoClass="w-22 h-12"
					skills={(
						t("xp.4.list", {
							returnObjects: true,
						}) as string[]
					)
						.slice(1)
						.map(unescapeSkillAnchors)}
					desc={
						<>
							<span className="font-bold">{t("context")}</span>:
							<p className="py-4">{t("xp.iemn.0")}</p>
							<span className="font-bold">{t("role")}</span>:
							<p className="py-4">{t("xp.iemn.1")}</p>
							<p>{t("xp.iemn.2")}</p>
							<ul className="pl-4 list-disc py-4">
								<li>{t("xp.iemn.3")}</li>
								<li>{t("xp.iemn.4")}</li>
								<li>{t("xp.iemn.5")}</li>
								<li>{t("xp.iemn.6")}</li>
							</ul>
							<p>{t("xp.iemn.7")}</p>
						</>
					}
				></Item>
			</div>
		</div>
	);
}
